var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "185498c0c9da062d5daf3694aa5f9326.png",
    width: 78,
    height: 78
});